import { render } from "./Step3.vue?vue&type=template&id=0a405fc6&scoped=true"
import script from "./Step3.vue?vue&type=script&lang=ts"
export * from "./Step3.vue?vue&type=script&lang=ts"

import "./Step3.vue?vue&type=style&index=0&id=0a405fc6&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-0a405fc6"

export default script